import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { FormGroup } from "@cofano/cck";
import { Grid2 as Grid } from "@mui/material";
import TimePicker from "components/cck/TimePicker";
import { Day } from "types/enums";
import { LocationSchemaInput, LocationSchemaOutput } from "view/locations/utils/location.schema";

const LocationOpeningHoursForm = () => {

	const { control } = useFormContext<LocationSchemaInput, unknown, LocationSchemaOutput>();

	return (
		<React.Fragment>
			{Object.values(Day).map(day => (
				<FormGroup
					label={intl.formatMessage({ id: day.toUpperCase() })}
					labelPlacement="left-center"
					overflow="hidden"
					key={day}>
					<Grid spacing={3} container>
						<Grid size={6}>
							<Controller
								name={`openingHours.${day}From`}
								control={control}
								render={({ field }) => <TimePicker {...field} placeholderText={intl.formatMessage({ id: "FROM" })} />} />
						</Grid>

						<Grid size={6}>
							<Controller
								name={`openingHours.${day}To`}
								control={control}
								render={({ field }) => <TimePicker {...field} placeholderText={intl.formatMessage({ id: "TO" })} />} />
						</Grid>
					</Grid>
				</FormGroup>
			))}
		</React.Fragment>
	);
};

export default LocationOpeningHoursForm;
